import React, { useState,useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  Form,
  FormFeedback,
  UncontrolledAlert,
  Spinner,FormGroup
} from "reactstrap";
import { get,post } from "../../Services/RestAPIService";
import { useParams, useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from 'react-i18next';
import Select from "react-select";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const ExerciseForm = () => {
  const { t } = useTranslation(); // Initialize useTranslation hook

  const [isLoading, setIsLoading] = useState(false);
  const [exerciseImage, setExerciseImage] = useState(null);
  const [videoLink, setVideoLink] = useState('');
  const [videoPlatform, setVideoPlatform] = useState('YouTube');
  const { subid, id } = useParams();
  const navigate = useNavigate();
  const [alert, setAlert] = useState({
    color: "",
    message: "",
    visible: false
  });
  const [dataOriginal, setDataOriginal] = useState([]);
  const [selectedData, setSelectedData] = useState(null); // State for selected data

  const [subcatData, setSubcatData] = useState([]);
  const [sbcSelectedData, setSbcSelectedData] = useState(null); // State for selected data

  const [exerciseData, setExerciseData] = useState([]);
  const [exselectedData, setExSelectedData] = useState(null); // State for selected data

  const [selectedCategories, setSelectedCategories] = useState([]); // for multiple parent categories
  const [subcategoriesMap, setSubcategoriesMap] = useState({}); // { parentId: [subcategories] }
  const [selectedSubcategories, setSelectedSubcategories] = useState({}); // { parentId: [selectedSubcategories] }


  const getUsersData = async () => {
    try {
      const usersData = await get(`category/categories/?parent_id_isnull=true`);
      if (usersData) {
        const formatted = usersData.results.map(category => ({
          label: category.name,
          value: category.id.toString(),
        }));

        usersData.results.forEach((category) => {
          if (category?.id?.toString() === subid) {
            handleParentChange([{label: category.name, value: category?.id?.toString()}])
          }
        });


        setDataOriginal(formatted);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  // const getUsersData = async () => {
  //   console.log("HEl")
  //   try {
  //     const usersData = await get(`category/categories/?parent_id_isnull=true`);
  //     if (usersData) {
  //       let formattedData = usersData.results.map((category) => ({
  //         label: category.name,
  //         value: category?.id?.toString(),
  //       }));

  //       usersData.results.forEach((category) => {
  //         if (category?.id?.toString() === subid) {
  //           setSelectedData({
  //             label: category.name,
  //             value: category?.id?.toString(),
  //           });
  //           getSubcatData(category?.id)
  //         }
  //       });

  //       setDataOriginal(formattedData);
  //     } else {
  //       console.error('No data found in the response.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching user data:', error);
  //   }
  // };

  //   Sub Data

  const fetchSubcategories = async (parentId) => {
    try {
      const res = await get(`category/categories/?parent_id=${parentId}`);
      const formatted = res.results.map(sub => ({
        label: sub.name,
        value: sub.id.toString(),
      }));

          res.results.forEach((category) => {
          if (category?.id?.toString() === id) {
            setSelectedSubcategories(prev => ({
              ...prev,
              [parentId]: {label: category.name, value: category?.id?.toString()},
            }))
          }
        });

      setSubcategoriesMap(prev => ({
        ...prev,
        [parentId]: formatted,
      }));
    } catch (err) {
      console.error("Subcategories fetch failed", err);
    }
  };
  
  
    const handleParentChange = (selected) => {
      setSelectedCategories(selected);
    
      selected.forEach((cat) => {
        if (!subcategoriesMap[cat.value]) {
          fetchSubcategories(cat.value);
        }
      });
    
      // Remove any unselected categories from selectedSubcategories
      const updated = {};
      selected.forEach((cat) => {
        if (selectedSubcategories[cat.value]) {
          updated[cat.value] = selectedSubcategories[cat.value];
        }
      });
      setSelectedSubcategories(updated);
      console.log(selectedCategories)
    };

    

  // const getSubcatData = async (catDataid) => {
  //   try {
  //     const SubcatData = await get(`category/categories/?parent_id=${catDataid}`);
  //     console.log(SubcatData, "SubcatData")
  //     if (SubcatData) {
  //       let formattedDataSubCat = SubcatData.results.map((category) => ({
  //         label: category.name,
  //         value: category.id.toString(),
  //       }));

  //       SubcatData.results.forEach((category) => {
  //         if (category?.id?.toString() === id) {
  //           setSbcSelectedData({
  //             label: category.name,
  //             value: category?.id?.toString(),
  //           });
  //         }
  //       });


  //       setSubcatData(formattedDataSubCat);
  //     } else {
  //       console.error('No data found in the response.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching user data:', error);
  //   }
  // };

  //   Exercise Data

  // const getExerciseData = async (Exerciseslug) => {
  //     try {
  //         const ExerciseData = await get(`exercise/exercises/?category_id=${Exerciseslug}`);

  //         console.log(ExerciseData, "ExerciseData")


  //         if (ExerciseData) {
  //             let formattedDataExercise = ExerciseData.results.map((category) => ({
  //                 label: category.exercise_name,
  //                 value: category.id.toString(),
  //             }));
  //             setExerciseData(formattedDataExercise);
  //         } else {
  //             console.error('No data found in the response.');
  //         }
  //     } catch (error) {
  //         console.error('Error fetching user data:', error);
  //     }
  // };


  useEffect(() => {

    if (selectedData) {
      null
    } else {

      getUsersData();
    }

    // if (selectedData) {

    // }


  }, []);



  const validation = useFormik({
    initialValues: {
      exercise_name: '',
      monthly: 0,
      yearly: 0,
      weekly: 0,
      once: 0,
      Description: '',
      Status: true,
      Image: '',
      videoLink: videoLink,
      subcatData: ''
    },

    validationSchema: Yup.object({
      exercise_name: Yup.string().required(t("Please Enter Exercise Name")),
      Description: Yup.string().required(t("Please Enter Description")),
      // subcatData: (id === "id" ? Yup.object().required(t('Please select a Sub-Category')) : null)
      // videoLink: Yup.string().url(t("Invalid URL format")).required(t("Please Enter Video Link"))
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);

      const categoryIds = Object.values(selectedSubcategories)
      .flat()
      .map((item) => Number(item.value));
    

console.log(categoryIds,"categoryIds")
      const Data = {
        "exercise_name": values.exercise_name,
        "monthly": values.monthly,
        "yearly": values.yearly,
        "weekly": values.weekly,
        "once": values.once,
        "description": values.Description,
        "status": values.Status,
        "image": exerciseImage,
        "video_link": videoLink,
        "video_platform": videoPlatform,
        "category_id": categoryIds[0],  
        "categories":categoryIds
      }
      try {
        const response = await post(`exercise/exercises/`, Data, {
          headers: { 'Content-Type': 'application/json' },
          validateStatus: false
        });
        console.log(response)
        if (response.status <= 399) {
          validation.setValues(validation.initialValues);
          validation.setErrors({});
          resetForm(); // Reset the form

          setAlert({
            color: "success",
            visible: true,
            message: t("Exercise created successfully!")
          });
          setTimeout(() => {
            navigate(`/category/exercise/${subid === "id"? selectedData.value : subid }/${ id === "id"? sbcSelectedData.value: id}`)
          }, 1500);

        } else {
          let errorMessage = t("An error occurred while creating exercise.");
          for (const key in response.data) {
            if (Array.isArray(response.data[key]) && response.data[key].length > 0) {
              errorMessage = `${key}: ${response.data[key][0]}`;
              break;
            }
          }
          setAlert({
            color: "danger",
            visible: true,
            message: errorMessage
          });
        }
      } catch (error) {
        console.error('Error creating exercise:', error);
        setAlert({
          color: "danger",
          visible: true,
          message: t("An error occurred while creating exercise.")
        });
      } finally {
        setIsLoading(false);
        setTimeout(() => {
          setAlert({
            visible: false,
          });
        }, 3000);

      }
    }
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setExerciseImage(base64String); // Assuming setProfileImage is a state setter function
      };
      reader.readAsDataURL(file);
    }
  };

  const handleVideoLinkChange = (event) => {
    setVideoLink(event.target.value);
    validation.setFieldValue('videoLink', event.target.value);
  };


  const handleVideoPlatformChange = (event) => {
    setVideoPlatform(event.target.value);
  };


  const getVideoEmbedUrl = (platform, link) => {
    switch (platform) {
      case 'YouTube':
        return `https://www.youtube.com/embed/${encodeURIComponent(getYoutubeVideoId(link))}?si=9552mlr0hYutmQ9k`;
      case 'Vimeo':
        return `https://player.vimeo.com/video/${getVimeoVideoId(link)}?h=3eb6a365ec`;
      case 'Dailymotion':
        return `https://www.dailymotion.com/embed/video/${getDailymotionVideoId(link)}`;
      case 'Wistia':
        return `https://fast.wistia.net/embed/iframe/${getWistiaVideoId(link)}`;
      default:
        return '';
    }
  };


  const getYoutubeVideoId = (link) => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = link.match(regex);
    return match ? match[1] : '';
  };


  const getVimeoVideoId = (link) => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)/;
    const match = link.match(regex);
    return match ? match[1] : '';
  };





  return (
    <React.Fragment>
      {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={alert.color}>{alert.message}</UncontrolledAlert>}
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs maintitle="Home" title={t("Exercises")} titleLink={`/category/exercise/${subid === "id"? Number(selectedData?.value) : subid }/${ id === "id"? Number(sbcSelectedData?.value) : id}`} breadcrumbItem={t("Add New Exercise")} />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle>{t("Create New Exercise")}</CardTitle>
                  <CardSubtitle className="mb-3">
                    {t("Fill in the details below to create a new exercise.")}
                  </CardSubtitle>
                  <Form onSubmit={validation.handleSubmit}>






                     <>

                      <FormGroup className="mb-3">

                        <Label className="form-label">{t('Select Parent Category')}</Label>
                        <Select
                         isMulti
                         name="parentCategories"
                         value={selectedCategories}
                         options={dataOriginal}
                         onChange={handleParentChange}
                          // value={selectedData}
                          // name="categorySelected"
                          // onChange={(selectedOption) => {
                          //   console.log(selectedOption,"selectedOption")
                          //   setSelectedData(selectedOption);
                          //   validation.setFieldValue('categorySelected', selectedOption); // Set formik value
                          //   getSubcatData(Number(selectedOption?.value));
                          // }}
                          onBlur={validation.handleBlur}
                          // options={dataOriginal}
                          classNamePrefix="select2-selection"
                        />
                        {validation.touched.categorySelected && validation.errors.categorySelected && (
                          <FormFeedback type="invalid">{validation.errors.categorySelected}</FormFeedback>
                        )}
                      </FormGroup>

                      {/* ff */}


                      {selectedCategories.map((cat) => (
                          <FormGroup key={cat.value} className="mb-3">
                            <Label>
                              {t("Select Body Parts for")} <strong>{cat.label}</strong>
                            </Label>
                            <Select
                              isMulti
                              name={`bodyParts-${cat.value}`}
                              options={subcategoriesMap[cat.value] || []}
                              value={selectedSubcategories[cat.value] || []}
                              onChange={(selected) =>[
                                console.log(selected,selectedSubcategories),
                                setSelectedSubcategories(prev => ({
                                  ...prev,
                                  [cat.value]: selected,
                                }))
                              ]}
                            />
                          </FormGroup>
                        ))}


                      {/* <FormGroup className="mb-3">
                        <Label className="form-label">{t('Select Body Part')}</Label>
                        <Select
                          value={sbcSelectedData}
                          name="subcatData"
                          onChange={(selectedOption) => {
                            setSbcSelectedData(selectedOption);
                            validation.setFieldValue('subcatData', selectedOption);
                          }}
                          onBlur={validation.handleBlur}
                          options={subcatData}
                          classNamePrefix="select2-selection"
                        />
                        <p type="invalid" style={{ color: "#ec4561", fontSize: "80%" }}>{validation.errors.subcatData}</p>
                        {validation.touched.subcatData && validation.errors.subcatData && (
                          <FormFeedback type="invalid">{validation.errors.subcatData}</FormFeedback>
                        )}
                      </FormGroup> */}

                      {/* ) */}
                      {/* // } */}





                      {/* {id === "id" && ( */}
                      {/* <FormGroup className="mb-3">
                                            <Label className="form-label">{t('Select Exercise')}</Label>
                                            <Select
                                                value={exselectedData}
                                                name="exerciseData"
                                                onChange={(selectedOption) => {
                                                    setExSelectedData(selectedOption);
                                                    validation.setFieldValue('exerciseData', selectedOption.value); // Set formik value
                                                }}
                                                onBlur={validation.handleBlur}
                                                options={exerciseData}
                                                classNamePrefix="select2-selection"
                                            />
                                                <p type="invalid" style={{color:"#ec4561",fontSize:"80%"}}>{validation.errors.exerciseData}</p>

                                        </FormGroup> */}


                    </>








                    <div className="mb-3">
                      <Label className="form-label">{t("Exercise Name")}</Label>
                      <Input
                        name="exercise_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.exercise_name || ""}
                        invalid={validation.touched.exercise_name && validation.errors.exercise_name}
                      />
                      {validation.touched.exercise_name && validation.errors.exercise_name && (
                        <FormFeedback type="invalid">{validation.errors.exercise_name}</FormFeedback>
                      )}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">{t("Description")}</Label>
                      <Input
                        type="textarea"
                        name="Description"
                        rows="5"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.Description || ""}
                        invalid={validation.touched.Description && validation.errors.Description}
                      />
                      {validation.touched.Description && validation.errors.Description && (
                        <FormFeedback type="invalid">{validation.errors.Description}</FormFeedback>
                      )}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">{t("Status")}</Label>
                      <Input
                        type="select"
                        name="Status"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.Status || false}
                        invalid={validation.touched.Status && validation.errors.Status}
                      >
                        <option value={true}>{t("Active")}</option>
                        <option value={false}>{t("Inactive")}</option>
                      </Input>
                      {validation.touched.Status && validation.errors.Status && (
                        <FormFeedback type="invalid">{validation.errors.Status}</FormFeedback>
                      )}
                    </div>
                    {/* 
                    <div className="mb-3">
                      <Label className="form-label">{t("Select Video Platform")}</Label>
                      <Input
                        type="select"
                        name="videoPlatform"
                        onChange={handleVideoPlatformChange}
                        value={videoPlatform}
                      >
                        <option value="YouTube">{t("YouTube")}</option>
                        <option value="Vimeo">{t("Vimeo")}</option>
                      </Input>
                    </div> */}

                    {/* <div className="mb-3">
                      <Label className="form-label">{t("Video Link")}</Label>
                      <span className="text-muted">{t(`  ${t("Please Enter")} ${videoPlatform} ${t("Video link")}:`)}</span>
                      <Input
                        type="text"
                        name="videoLink"
                        onChange={handleVideoLinkChange}
                        onBlur={validation.handleBlur}
                        value={videoLink}
                        invalid={validation.touched.videoLink && validation.errors.videoLink}
                      />
                      {validation.touched.videoLink && validation.errors.videoLink && (
                        <FormFeedback type="invalid">{validation.errors.videoLink}</FormFeedback>
                      )}
                      {videoLink && (
                        <div className="mt-3">
                          <iframe
                            width="100%"
                            height="100%"
                            src={getVideoEmbedUrl(videoPlatform, videoLink)}
                            frameBorder="0"
                            allowFullScreen
                            title="Video Preview"
                          ></iframe>
                        </div>
                      )}
                    </div> */}

                    <div className="mb-3">
                      <Label className="form-label">{t("Image")}</Label>
                      <Input
                        type="file"
                        name="Image"
                        onChange={handleImageChange}
                      />
                    </div>

                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" disabled={isLoading}>
                        {isLoading ? <Spinner size="sm" color="light" /> : t("Create")}
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ExerciseForm;
